import { render, staticRenderFns } from "./DASweetConfirm.vue?vue&type=template&id=0c60d8f0&scoped=true"
import script from "./DASweetConfirm.vue?vue&type=script&lang=js"
export * from "./DASweetConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60d8f0",
  null
  
)

export default component.exports